window.Sparkle ??= {};
window.Sparkle.PageBuilder ??= {};

Sparkle.PageBuilder.Wysiwyg = _.extend({ Wysiwyg: {} }, Sparkle.PageBuilder.Wysiwyg);
